import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const QualityReviewDocumentRoute = LazyLoad(
  lazy(() =>
    import('./quality-review-document').then((module) => ({
      default: module.QualityReviewDocument,
    })),
  ),
);
